import { render } from "./PurchaseRegisterSprinklrCallback.vue?vue&type=template&id=40d44794&scoped=true&ts=true"
import script from "./PurchaseRegisterSprinklrCallback.vue?vue&type=script&lang=ts"
export * from "./PurchaseRegisterSprinklrCallback.vue?vue&type=script&lang=ts"

import "./PurchaseRegisterSprinklrCallback.vue?vue&type=style&index=0&id=40d44794&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d44794"]])

export default __exports__